import { PlainModal } from '@client/new/components/Modal/Modal';
import { Button, CircularProgress, Typography } from '@mui/material';

type ResetDomainModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isSubmitting: boolean;
};

export const ResetDomainModal = (p: ResetDomainModalProps) => {
  return (
    <PlainModal
      isOpen={p.isOpen}
      onClose={p.onClose}
      height={'auto'}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        padding: '24px',
      }}
      disableBackdropClick={true}
    >
      <Typography className="font-bold text-2xl">
        Are you sure you want to reset your domain?
      </Typography>
      <Typography>This action cannot be undone.</Typography>
      <div className="flex justify-end gap-7">
        <Button variant="text" onClick={p.onClose} disabled={p.isSubmitting}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={p.onConfirm}
          disabled={p.isSubmitting}
        >
          {p.isSubmitting ? (
            <CircularProgress className="w-4 h-4" />
          ) : (
            'Reset Domain'
          )}
        </Button>
      </div>
    </PlainModal>
  );
};
